import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'

export async function uploadExpenseAttachment(file: File, expenseId: string): Promise<string> {
  try {
    const storage = getStorage()
    const fileRef = ref(storage, `attachments/${expenseId}/${file.name}`)
    await uploadBytes(fileRef, file)
    return await getDownloadURL(fileRef)
  } catch (err: any) {
    throw new Error(err.message || 'Failed to upload attachment')
  }
}
